import React from "react";
import LegalPage from "../../components/Kids/LegalPage";
import Seo from "../../components/Seo";
import SEO from "../../seo/pages.json";
import { faqSchema } from "../../utils/structuredData";
import { KIDS_FAQ } from "../../data/kidsFaq";

export default function KidsFAQPage() {
  return (
    <LegalPage title="Frequently Asked Questions">
      <Seo
        {...SEO["/kids/faq"]}
        path="/kids/faq"
        jsonLd={[faqSchema(KIDS_FAQ)]}
      />

      <div className="space-y-5">
        {KIDS_FAQ.map((f) => (
          <div key={f.q}>
            <h2>{f.q}</h2>
            <p>{f.a}</p>
          </div>
        ))}
      </div>
    </LegalPage>
  );
}
